module.exports = __webpack_public_path__ + "Lato-Black.d94348c243cef5e12e36.eot";


//////////////////
// WEBPACK FOOTER
// /home/alee/projects/egis-rse-dev/src/assets/fonts/Lato-Black.eot
// module id = ../../../../../src/assets/fonts/Lato-Black.eot
// module chunks = styles